import styled, { css } from 'styled-components';
import Button from '../../../_shared/components/Button';
import { StyledTradeEmpty } from '../../TradeCardEmpty/Styles';
import { StyledInvalidTradeCard } from '../ListTradeCard/Styles';

export const TradeCard = styled(StyledTradeEmpty)`
  flex-direction: column;
  padding-bottom: 19px;
  position: relative;
  border-radius: 3px;
  display: flex;
`;

export const StyledPendingInvalidTradeCard = styled(StyledInvalidTradeCard)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  box-shadow: none;
`;

export const TradeContentContainer = styled.div`
  position: relative;
`;

export const ExternalContainer = styled.div`
  padding-top: 17px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Row = styled.div`
  flex-direction: row;
  display: flex;
`;

export const Column = styled.div`
  flex-direction: column;
  display: flex;
  padding-left: 18px;
`;

export const FitContent = styled.div`
  flex-basis: auto;
  display: flex;
`;

const fontStyle = css`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-style: normal;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: left;
`;

const bidLabelHighlighted = css`
  color: ${({ theme }) => theme.COLORS.MONZA};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;

const bidHighlighted = css`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  align-items: center;
  flex-direction: row;
  display: flex;
`;

export const BidInfoTitle = styled.div`
  ${FitContent.css}
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  ${fontStyle}
  ${props => (props.highlightBidLabel ? bidLabelHighlighted : '')}
`;

export const BidInfoValue = styled.div`
  ${FitContent.css}
  ${fontStyle}
  ${props => (props.highlightBidValue ? bidHighlighted : '')};
  margin-top: 3px;
`;

export const ProxyInfoTitle = BidInfoTitle;
export const ProxyInfoValue = BidInfoValue;

export const BlueDot = styled.div`
  height: 6px;
  width: 6px;
  background-color: ${({ theme }) => theme.COLORS.TERTIARY};
  border-radius: 50%;
  display: inline-block;
  margin-right: 3px;
`;

export const LeftContainer = styled.div`
  flex-direction: row;
  flex-grow: 1;
`;

const ButtonStyle = css`
  margin-right: 18px;
`;

const DisableButtonStyle = css`
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const StyledSecondaryButton = styled(Button.Secondary)`
  ${ButtonStyle}
  padding: 10px 12px;
  letter-spacing: 0px;
  ${DisableButtonStyle}
`;

export const StyledPrimaryButton = styled(Button.Primary)`
  ${ButtonStyle}
  padding: 10px 12px;
  ${DisableButtonStyle}
`;

export const NegotiationEndReason = styled.div`
  margin-top: auto;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;
